import React, { FunctionComponent } from "react";

const FlagPlainIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="13"
      viewBox="0 0 11 13"
    >
      <path
        d="M0.93457 2.06763C0.93457 1.79149 1.15843 1.56763 1.43457 1.56763H4.9838V7.48345C4.9838 7.75959 4.75995 7.98345 4.4838 7.98345H1.43457C1.15843 7.98345 0.93457 7.75959 0.93457 7.48345V2.06763Z"
        fill="currentColor"
      />
      <path
        d="M4.98389 0.500005C4.98389 0.223855 5.20775 0 5.48389 0H9.16126V6.41582H4.98389V0.500005Z"
        fill="currentColor"
      />
      <path
        d="M9.16126 0H10.5C10.7762 0 11 0.223855 11 0.499995V12.1792C11 12.4554 10.7762 12.6792 10.5 12.6792H9.66113C9.38499 12.6792 9.16113 12.4554 9.16113 12.1792L9.16126 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FlagPlainIcon;
